import React from 'react';
import { GetSubjectDetails, GetSubjectsDropDownList, GetTopComplaintSubjects } from 'api/apiService';
import Const from 'const.json';
import ComplaintList from 'components/controls/ComplaintList/ComplaintList';
import { useYearFromRedux } from 'utils/utilsLogic';

const TopComplaintSubjects: React.FC = () => {
    const { comparisonTextToLastYear } = useYearFromRedux();

    return (
        <ComplaintList showIcon={false}
            fetchData={GetTopComplaintSubjects}
            fetchDetails={GetSubjectDetails}
            headerText={Const.TopComplaintSubjects}
            subheaderText={comparisonTextToLastYear}
            isShowDetails={false}
            options={GetSubjectsDropDownList}
            title={Const.selectSubject}
            placeholder={Const.typeNameOfSubject}
            onSelect={GetTopComplaintSubjects}
        />
    );
};

export default TopComplaintSubjects;
